module.exports = __webpack_public_path__ + "img/request.2512fa93.png";